import { Address, useDaumPostcodePopup } from 'react-daum-postcode';

export type SearchedAddress = {
  /** 도로명 주소의 경우 법정동/건물명을 괄호로 덧붙인 전체 주소 */
  address: string;
  zipCode: string;
};

/**
 * 다음 주소 검색 결과를 화면에 그대로 넣을 수 있는 형태로 조립한다.
 * 지번 주소(addressType === 'J')는 덧붙일 정보가 없어 주소를 그대로 쓴다.
 */
const buildAddress = (data: Address): SearchedAddress => {
  let fullAddress = data.address;

  if (data.addressType === 'R') {
    let extraAddress = '';

    if (data.bname !== '') {
      extraAddress += data.bname;
    }
    if (data.buildingName !== '') {
      extraAddress +=
        extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
    }
    fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
  }

  return { address: fullAddress, zipCode: data.zonecode };
};

/**
 * 다음 주소 검색 팝업을 열고, 선택한 주소를 onSelect로 넘긴다.
 * 결과를 폼에 반영하는 방식(setValue / setState)은 호출하는 쪽에 맡긴다.
 */
export const useAddressSearch = (
  onSelect: (result: SearchedAddress) => void,
) => {
  const openPostcodePopup = useDaumPostcodePopup();

  return () => {
    openPostcodePopup({ onComplete: (data) => onSelect(buildAddress(data)) });
  };
};
